/** UUID estable de persona física. */
export const SUPPLIER_PERSON_FISICA_UUID =
  'a34bd14c-91c2-42d9-9264-b8adda28c5c5';

/** UUID estable de persona moral. */
export const SUPPLIER_PERSON_MORAL_UUID =
  'd1e3364b-5cb6-415d-a9b4-3aa52e34aefc';

/** UUID estable de la condición de pago Contado. */
export const SUPPLIER_CASH_PAYMENT_CONDITION_UUID =
  '0d92013e-6219-45fe-9070-17d686a085f3';

/**
 * UUID estable de la condición de pago Crédito.
 * `paymentCondition` solo publica `uuid` y `name`; este UUID es lo que
 * indica que la edición debe capturar límite y plazo.
 */
export const SUPPLIER_CREDIT_PAYMENT_CONDITION_UUID =
  '950a361d-41ce-4a41-aed9-e9d9915ce78e';

export type SupplierSelectDto = {
  uuid: string;
  name: string;
};

export type SupplierToneDto = {
  name: string;
  value: string;
  tone: string;
};

export type SupplierAddressDto = {
  street: string;
  exteriorNumber: string;
  interiorNumber: string | null;
  colony: string;
  zipCode: string;
  country: SupplierSelectDto;
  state: SupplierSelectDto;
  municipality: SupplierSelectDto;
};

export type SupplierGridDto = {
  uuid: string;
  id: number;
  name: string;
  type: SupplierSelectDto;
  rfc: string;
  curp: string | null;
  paymentCondition: SupplierSelectDto;
  creditLimit: number | null;
  creditTermDays: number | null;
  status: SupplierToneDto;
};

export type SupplierDto = {
  uuid: string;
  id: number;
  name: string;
  type: SupplierSelectDto;
  businessName: string | null;
  rfc: string;
  curp: string | null;
  societyType: SupplierSelectDto | null;
  paymentCondition: SupplierSelectDto;
  creditLimit: number | null;
  creditTermDays: number | null;
  notes: string | null;
  address: SupplierAddressDto | null;
  status: SupplierToneDto;
  createdAt: string;
  updatedAt: string;
};

export type SupplierAddressRequest = {
  street: string;
  exteriorNumber: string;
  interiorNumber: string | null;
  colony: string;
  zipCode: string;
  countryUuid: string;
  stateUuid: string;
  municipalityUuid: string;
};

/**
 * Alta y edición. Límite y plazo se envían solo con la condición Crédito.
 */
export type SupplierCreateRequest = {
  personTypeUuid: string;
  displayName?: string;
  businessName?: string;
  rfc: string;
  curp?: string;
  societyTypeUuid?: string;
  paymentConditionUuid: string;
  creditLimit?: number;
  creditTermDays?: number;
  notes: string | null;
  address: SupplierAddressRequest;
};

export type SupplierUpdateRequest = SupplierCreateRequest;

export type SupplierListQuery = {
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  name?: string;
  rfc?: string;
  curp?: string;
  typeUuids?: readonly string[];
  paymentConditionUuids?: readonly string[];
  statusUuids?: readonly string[];
};

export type SupplierListResult = {
  items: SupplierGridDto[];
  total: number;
};

export type SupplierFormSelects = {
  personTypes: SupplierSelectDto[];
  societyTypes: SupplierSelectDto[];
  paymentConditions: SupplierSelectDto[];
  countries: SupplierSelectDto[];
};

export type SupplierFilterSelects = {
  statuses: SupplierSelectDto[];
  personTypes: SupplierSelectDto[];
  paymentConditions: SupplierSelectDto[];
};

export type SupplierEditForm = {
  supplier: SupplierDto;
  selects: SupplierFormSelects;
};

export type SupplierApiDownload = {
  blob: Blob;
  filename: string;
};
